
/*
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class VisDefinitionState
 * @hideconstructor
 * @classdesc Implementation class for VisDefinitionStateApi that is used to control a vis definition state
 */
define([
	'../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../VisDefinitionStateAPI'
], (APIFactory, VisDefinitionStateAPI) => {

	class VisDefinitionState {

		getAPI () {
			if (!this._api) {
				this._api = APIFactory.createAPI(this, [ VisDefinitionStateAPI ]);
			}
			return this._api;
		}

		destroy() {
			this._api = null;
		}

		/**
		 * @implements VisDefinitionStateAPI#getError
		 */
		getError() {
			return this._error;
		}

		/**
		 * Is not exposed as a public API
		 * @param {Error} error object 
		 */
		setError(error) {
			this._error = error;
		}
	}

	return VisDefinitionState;
});